export default __webpack_public_path__ + "static/media/work-11.f727e1fe.jpg";